import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { lighten } from '@material-ui/core/styles/colorManipulator'
import { drawerBackdropBlurStyle, transition } from '../../../shared/style-settings'

export const useAppHeaderDrawerStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdropBlur: drawerBackdropBlurStyle,
    hamburger: {
      display: 'none',

      [theme.breakpoints.down('sm')]: {
        display: 'inline-flex',
      },
    },

    list: {
      width: 280,
      boxSizing: 'border-box',
      padding: theme.spacing(1, 1.5, 2, 1),

      '& a': {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        fontWeight: 600,
      },

      '& .MuiListItem-root:hover a': {
        color: theme.palette.common.white,
      },

      '& .MuiListItem-root': {
        fontWeight: 600,
        padding: theme.spacing(1.25, 2.5),
        margin: theme.spacing(0.25, 0),
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          transform: 'translateX(4px)',
        },
        '&:active': {
          backgroundColor: theme.palette.primary.dark,
        },
      },

      '& .MuiListItemText-primary': {
        fontWeight: 600,
        fontSize: '0.9375rem',
      },

      '& .MuiListItem-root:hover .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },

      '& .MuiListItemIcon-root': {
        minWidth: 40,
        color: lighten(theme.palette.primary.main, 0.14),
        transition: transition,
      },

      '& .MuiListItem-root:hover .MuiListItemIcon-root': {
        color: theme.palette.common.white,
      },

      '& hr': {
        margin: theme.spacing(1.5, 2),
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
    },

    listBottom: {
      boxSizing: 'border-box',
      padding: theme.spacing(2, 1.5),
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: 'auto',

      '& .MuiListItem-root:hover a': {
        color: theme.palette.common.white,
      },

      '& .MuiListItem-root': {
        fontWeight: 600,
        padding: theme.spacing(1.25, 2.5),
        margin: theme.spacing(0.25, 0),
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          transform: 'translateX(4px)',
        },
        '&:active': {
          backgroundColor: theme.palette.primary.dark,
        },
      },

      '& .MuiListItemText-primary': {
        fontWeight: 600,
        fontSize: '0.9375rem',
      },

      '& .MuiListItem-root:hover .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },

      '& .MuiListItemIcon-root': {
        minWidth: 40,
        color: lighten(theme.palette.primary.main, 0.14),
        transition: transition,
      },

      '& .MuiListItem-root:hover .MuiListItemIcon-root': {
        color: theme.palette.common.white,
      },
    },

    listHolder: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      backgroundColor: theme.palette.background.paper,
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    drawerPaper: {
      width: 280,
      boxShadow: theme.shadows[8],
      overflowX: 'hidden',
    },
    drawerHeader: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing(0.5, 0.5, 0, 0.5),
    },
    closeButton: {
      color: theme.palette.text.secondary,
      transition: transition,
      '&:hover': {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover,
      },
    },
    userProfileBlock: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2, 2.5),
      marginBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      background: `linear-gradient(135deg, ${theme.palette.primary.main}10 0%, ${theme.palette.primary.light}20 100%)`,
    },
    userAvatar: {
      width: 56,
      height: 56,
      border: `3px solid ${theme.palette.primary.main}`,
      boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
    },
    userInfo: {
      marginLeft: theme.spacing(2),
      overflow: 'hidden',
      flex: 1,
    },
    userName: {
      fontWeight: 600,
      fontSize: '1rem',
      color: theme.palette.text.primary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 1.3,
    },
    userEmail: {
      fontWeight: 400,
      fontSize: '0.8125rem',
      color: theme.palette.text.secondary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: theme.spacing(0.25),
    },
  })
)
